﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import TypeOfClaim from "./Registration/TypeOfClaim.svelte";
import LivingClaimants from "./Registration/LivingClaimants.svelte";
import SpouseChildClaimants from "./Registration/SpouseChildClaimants.svelte";
import ClaimantsId from "./Registration/ClaimantsId.svelte";
import BankDetails from "./Registration/BankDetails.svelte";
import AdditionalInfo from "./Registration/AdditionalInfo.svelte";
import ConfirmationConsent from "./Registration/ConfirmationConsent.svelte";


const confirmationPages = [
    {
        component: LandingPage,
        routeId: "/Registration",
        confirmationHeading: null,
        editable: false,
    },
    {
        component: PersonalDetails,
        routeId: "/Registration/PersonalDetails",
        confirmationHeading: "Your details",
    },
    {
        component: TypeOfClaim,
        routeId: "/Registration/TypeOfClaim",
        confirmationHeading: "Type Of Claim",
    },
    {
        component: LivingClaimants,
        routeId: "/Registration/LivingClaimants",
        confirmationHeading: "Living Claimants",
        showComponent: (model) => {
            if (model && model.claimDetail && model.claimDetail.claimType === "My own claim") {
                return true;
            }
            return false;
        },
    },
    {
        component: SpouseChildClaimants,
        routeId: "/Registration/SpouseChildClaimants",
        confirmationHeading: "Spouse or Child Claimants",
        showComponent: (model) => {
            if (model && model.claimDetail && model.claimDetail.claimType === "My own claim") {
                return false;
            }
            return true;    // Always show except when own claim selected
        },
    },
    {
        component: ClaimantsId,
        routeId: "/Registration/ClaimantsId",
        confirmationHeading: "Claimants ID",
    },
    {
        component: BankDetails,
        routeId: "/Registration/BankDetails",
        confirmationHeading: "Bank Details",
    },
    {
        component: AdditionalInfo,
        routeId: "/Registration/AdditionalInfo",
        confirmationHeading: "Additional Information",
    },
    {
        component: ConfirmationConsent,
        routeId: "/Registration/ConfirmationConsent",
        confirmationHeading: "Confirmation",
        confirmationAvoid: "true",
    },
];

export default confirmationPages;